import { axiosInstnace as axios } from './util';
import { endPoints } from '../config';

export const getNearestLocation = async (latitude,longitude) => {
  try {
    const response = await axios.get(endPoints.getNearestLocation, {
      params: {
        latitude,
        longitude
      }
    });
    return response.data;
  } catch (error) {
    return {
      data: [],
      count: 0
    };
  }
};

export const getCityState = async () => {
  try {
    const response = await axios.get(endPoints.getCityState);
    return response.data.data.data;
  } catch (error) {
    return {
      data: [],
      count: 0
    };
  }
};

export const getState = async () => {
  try {
    const response = await axios.get(endPoints.getStateList);
    return response.data.data.data;
  } catch (error) {
    return {
      data: [],
      count: 0
    };
  }
};


export const audio = async (audiolength) => {
  try {
    // Max Audio Length for Audio Cost Calculation is 30 Sec
    audiolength = audiolength > 30 ? 30: audiolength; 
    const response = await axios.get(endPoints.audio, {params:{
      audiolength
    }});
    return response.data.data.data[0];
  } catch (error) {
    return {
      data: [],
      count: 0
    };
  }
};

export const adminLogin = async params => {
  try {
  const response= await  axios.post(endPoints.adminLogin, params)
    const  data  = response.data;

    return data;
  } catch (error) {
    return error;
  }
};


// WEBPACK FOOTER //
// ./web/util/interaction.js